// Mesmas regras do cms-api (POST /upload). Validar aqui evita o upload e dá o motivo antes do submit.
export const LIMITE_IMAGEM_KB = 300;

export const TIPOS_IMAGEM_ACEITOS = [
  'image/webp',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml',
];

const validarImagem = (arquivo: File): string | null => {
  if (!TIPOS_IMAGEM_ACEITOS.includes(arquivo.type)) {
    return 'Formato não permitido. Use WebP, JPEG, PNG, GIF ou SVG.';
  }

  const tamanhoEmKb = Math.ceil(arquivo.size / 1024);
  if (tamanhoEmKb > LIMITE_IMAGEM_KB) {
    return `Imagem com ${tamanhoEmKb} KB. O máximo permitido é ${LIMITE_IMAGEM_KB} KB. Exporte em WebP ou JPEG otimizado.`;
  }

  return null;
};

export default validarImagem;
